// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-time-count-field .campos[data-v-2d26ecbd] {\n  display: flex;\n  align-items: center;\n}\n.p-time-count-field .campos .input-horas[data-v-2d26ecbd] {\n  width: 70px;\n  margin-right: 10px;\n}\n.p-time-count-field .campos .input-minutos[data-v-2d26ecbd] {\n  width: 70px;\n}\n.p-time-count-field .campos .input-decimal[data-v-2d26ecbd] {\n  width: 70px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
